<section
  class="flex w-full flex-wrap items-center justify-start gap-6 bg-gradient-to-r from-[#0b254e] to-[#154fa0] px-4 py-6 text-white lg:flex-nowrap lg:gap-12"
  aria-labelledby="ticket-dashboard-summary-heading"
>
  <h2 id="ticket-dashboard-summary-heading" class="sr-only">Ticket summary</h2>
  <app-ticket-count-chart
    class="flex w-full max-w-full self-center md:w-auto"
    [tickets]="tickets"
    [isLoading]="isLoading"
    [ticketAggregate]="aggregate"
  ></app-ticket-count-chart>
  <app-ticket-type-chart
    class="hidden shrink-0 justify-center self-center md:flex xl:w-auto"
    [ticketAggregate]="aggregate"
    [isLoading]="isLoading"
    [tickets]="tickets"
  ></app-ticket-type-chart>

  <div class="ml-auto flex shrink-0 flex-col gap-1 md:self-end lg:-ml-10">
    <a
      routerLink="/tickets/insights"
      class="font-lato flex items-center gap-1 text-sm font-semibold text-white hover:underline"
      aria-label="View ticket insights, including trends, performance, and key metrics"
    >
      View ticket insights
      <mat-icon
        class="flex! h-4! w-4! items-center! justify-center! text-base!"
        aria-hidden="true"
        >arrow_forward</mat-icon
      >
    </a>
    <p class="font-lato text-xs text-white/50">
      Trends, performance, and key metrics
    </p>
  </div>
</section>
